export enum LockStatus {
  unknown = 0,
  checkedIn = 1,
  checkedOut = 2,
  alreadyCheckedOut = 3
}
